const findSelectedKeys = (urlToFind: string, itemList) => {
  for (const item of itemList) {
    if (item.url === urlToFind) {
      // Item found in the current level
      return [item.key];
    }

    if (item.children && Array.isArray(item.children)) {
      const childResult = findSelectedKeys(urlToFind, item.children);
      if (childResult) {
        // Item found in the children array
        return [item.key, ...childResult];
      }
    }
  }

  // Item not found
  return null;
};

export default findSelectedKeys;
